import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IContactAssignOwnerRequest {
	excludeContactIds?: string[];
	filter?: Api.IContactsFilterRequest;
	ownershipFilter?: Api.IOwnershipFilter;
	includeContactIds?: string[];
	newOwnerId: string;
}

export function useContactAssignOwnerMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async (request: IContactAssignOwnerRequest) => {
			return new Promise<Api.ISystemJob>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceWithOperationResults<Api.ISystemJob>(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: 'contact/owner/assign',
					}),
					'POST',
					request,
					result => {
						if (result.success && result.value) {
							resolve(result.value);
						} else {
							reject(result);
						}
					},
					error => reject(error)
				);
			});
		},
		onSuccess,
		onError,
	});
}
